import React from "react";
import * as styles from "./styles.module.scss";

const TransparentVideo = ({ webM, mov }) => {
  if (typeof window === `undefined`) return null;

  // Hate doing this user agent stuff but what can you do ¯\_(ツ)_/¯
  const getVideoSource = () => {
    const movSrc = mov?.asset?.url;
    const webMSrc = webM?.asset?.url;

    const userAgent = navigator.userAgent.toLowerCase();
    const isSafari = /^((?!chrome).)*safari/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.platform);

    if (isIOS || isSafari) {
      return movSrc;
    }

    return webMSrc;
  };

  return (
    <>
      <video
        className={styles.video}
        playsInline
        muted
        autoPlay
        loop
        src={getVideoSource()}
      />
    </>
  );
};

export default TransparentVideo;
